import classNames from 'classnames';
import Countdown from 'components/Countdown';
import SurveyProgress from 'components/ProgressBar';
import useProgressProvider from 'providers/ProgressProvider';
import useSessionProvider from 'providers/SessionProvider';
import useSurveyProvider from 'providers/SurveyProvider';
import { Tooltipster } from 'react-tooltipster';

export default function Header({ logo }) {
    const { survey, status, total_question } = useSessionProvider();
    const { showProgress, progress, done, total } = useProgressProvider();
    const { timeFlag, remainingTime } = useSurveyProvider();
    console.log(status);
    console.log(total_question);
    {
        console.log('show pogress', { showProgress, total });
    }
    return (
        <header className={classNames('header', status?.toLowerCase())}>
            <div className="container">
                <div className="header__inner">
                    <div>
                        {status === 'Completed' && (
                            <img
                                src={survey.thankyouPage.logo === null ? logo : survey.thankyouPage.logo}
                                className="logo"
                                alt=""
                            />
                        )}
                        {status === 'Unsubscribed' && (
                            <img
                                src={survey.unsubscribePage.logo === null ? logo : survey.unsubscribePage.logo}
                                className="logo"
                                alt=""
                            />
                        )}
                        {status === 'Expired' && (
                            <img
                                src={survey.expirePage.logo === null ? logo : survey.expirePage.logo}
                                className="logo"
                                alt=""
                            />
                        )}
                        {status !== 'Completed' && status !== 'Unsubscribed' && status !== 'Expired' && (
                            <img src={logo} className="logo" alt="" />
                        )}
                    </div>

                    <div className="header-progress">
                        {showProgress && total > 0 && (
                            <div>
                                <p className="question-remaining">
                                    Survey Progress : {done} /{total}
                                </p>
                                <Tooltipster
                                    className="sentiment-link"
                                    side="left"
                                    placement="top-right"
                                    theme="tooltipster-light"
                                    content={<p style={{ whiteSpace: 'pre-line' }}>({progress}%)</p>}>
                                    <SurveyProgress {...{ value: progress }} />
                                </Tooltipster>
                            </div>
                        )}
                        {timeFlag && remainingTime > 0 && (
                            <p className="time-remaining">
                                <Countdown />
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
}
